import constant from 'lodash/constant';
import keyBy from 'lodash/keyBy';
import React from 'react';

import { APPROVAL_TYPES } from './constants';

const approvalTypes = [
  {
    type: APPROVAL_TYPES.budget,
    reason: 'High-value opportunities (>EUR 250K) need a budget approval.',
    whoCanGrant: () => (
      <span>
        Sales Cockpit users with the role{' '}
        <span className="font-weight-bold">(S)PC Lead or ZMS Management</span>{' '}
        can grant this Approval.
      </span>
    ),
    renderTargetRepresentation: approval => (
      <a href={`/opportunities/${approval.opportunityId}/show`}>
        this opportunity
      </a>
    ),
    mayRequest: (approvals, quoteId) =>
      // In quote screen only creative approvals need to be shown
      !approvals.some(({ type }) => type === APPROVAL_TYPES.budget) && !quoteId,
    seedData: constant({ type: APPROVAL_TYPES.budget }),
  },
  {
    type: APPROVAL_TYPES.opportunityCampaignType,
    reason:
      'Campaigns with the types ZBD, HPTO, and CTO need approval from management.',
    whoCanGrant: () => (
      <span>
        Only the users with the role of{' '}
        <span className="font-weight-bold">Management</span> can grant this
        approval.
      </span>
    ),
    renderTargetRepresentation: approval => (
      <a href={`/opportunities/${approval.opportunityId}/show`}>
        this opportunity
      </a>
    ),
    mayRequest: (approvals, quoteId) =>
      // In quote screen only creative approvals need to be shown
      !approvals.some(
        ({ type }) => type === APPROVAL_TYPES.opportunityCampaignType,
      ) && !quoteId,
    seedData: constant({ type: APPROVAL_TYPES.opportunityCampaignType }),
  },
  {
    type: APPROVAL_TYPES.creatives,
    reason: (
      <>
        Quotes including ZMS Creative Products need an approval from
        <span className="font-weight-bold"> Creative AMs</span> in order to
        download or send the IO to the client.
      </>
    ),
    whoCanGrant: () => {},
    renderTargetRepresentation: approval => (
      <a href={`/quotes/${approval.quoteId}/edit`}>this quote</a>
    ),
    mayRequest: (approvals, currentQuoteId) =>
      Boolean(
        currentQuoteId &&
          !approvals.some(
            ({ type, quoteId }) =>
              type === APPROVAL_TYPES.creatives && quoteId === currentQuoteId,
          ),
      ),
    seedData: quoteId => ({
      type: APPROVAL_TYPES.creatives,
      quoteId,
    }),
  },
];

export default approvalTypes;
export const byType = keyBy(approvalTypes, 'type');
